import React, { useState } from "react";
import PropTypes from "prop-types";
import { useAuthContext } from "@src/context";
import { trackActionActivity } from "@src/utils/userActivityTracker";
import AppUtils from "@src/utils/appUtils";
import { useOperatorContext } from "@src/context/operatorContext";
import OperatorHooks from "@src/context/hooks/operatorHooks";
import { BackButton, Button } from "@src/components/atoms";
import CardContainer from "@src/components/cards/CardContainer";
import SupportForm from "@src/components/forms/operator/SupportForm";
import FAQList from "@src/pages/sharedSections/FAQList";
import DefinitionsAndFAQsSection from "@src/pages/sharedSections/DefinitionsAndFAQsSection";
import ErrorPage from "@src/components/layout/ErrorPage";

const SupportPage = () => {
  const { profile, setOnboardingOpen, getFirstName, getLastName } =
    useOperatorContext();
  const auth = useAuthContext();
  const { customer } = profile;

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isChanged, setIsChanged] = useState(null);

  const {
    data: { exclusions } = {},
    isPending: isPendingExclusions,
    error: errorExclusions,
  } = OperatorHooks.useBehaviourExclusions(profile.operator.id);

  const mutationCallback = (status) => {
    setIsSubmitting(false);
    setIsChanged(status);
  };
  const mutation = OperatorHooks.useSubmitSupportRequest(mutationCallback);

  const supportObject = {
    organization: customer.customerCode || "",
    fullname: `${getFirstName()} ${getLastName()}`,
    email: auth.user.username || "",
    issue: "assistance",
    message: "",
  };

  const isPageError = !profile || !customer;

  if (!!isPageError) {
    return <ErrorPage pageName={"support"} />;
  }
  return (
    <>
      <DefinitionsAndFAQsSection
        mode="OPERATOR"
        customer={customer}
        handleOpenOnboarding={() => setOnboardingOpen("support")}
        handleSubmitSupportForm={(message) => {
          setIsSubmitting(true);
          mutation.mutate({ ...supportObject, message });
          trackActionActivity("SUPPORT_REQUEST", {
            organization: profile.customer.customerCode,
            fullname: `${getFirstName() || ""} ${getLastName() || ""}`,
            email: auth.user.username,
            issue: "assistance",
            message,
          });
        }}
        isLoadingBvrExclusions={isPendingExclusions}
        bvrExclusions={exclusions}
      />
    </>
  );
};

export const supportPageControls = {};
SupportPage.propTypes = AppUtils.getPropTypeFromControls(supportPageControls);

export default SupportPage;
